import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box, useToast, Text, Table, Thead, Tbody, Tr, Th, Td, Button, Input,
} from '@chakra-ui/react';
import styled from 'styled-components';

import ThreeDotMenu from '../components/ThreeDotMenu';
import { getTicketDetails } from '../actions/playerTicketAction';
import './TicketDetails.css';

const CardContainer = styled.div`
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin: 20px auto 30px;
  padding: 20px;
  width: 100%;
  background: ${({ $red }) => ($red ? 'red' : '#fff')};
  color: ${({ $red }) => ($red ? '#fff' : '#000')};
`;

const SearchBarcode = () => {
  const dispatch = useDispatch();
  const toast = useToast();

  const [inputTicketID, setInputTicketID] = useState('');
  const [ticketId, setTicketID] = useState(null);

  const { ticketDetails, loadingTD, errorTD } = useSelector((state) => state.playerTicketDetails);

  const formatToIST = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
  };

  const fetchTicketDetails = () => {
    if (inputTicketID) {
      setTicketID(inputTicketID);
      dispatch(getTicketDetails(inputTicketID)).catch((err) =>
        toast({
          title: 'Error fetching ticket details',
          description: err.message,
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
      );
    } else {
      toast({
        title: 'Input required',
        description: 'Please enter a Ticket ID.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box p={4}>
      <CardContainer $red>
        <Text fontSize="xl" fontWeight="bold">Ticket Details Viewer</Text>
        <Box mt={4} display="flex" gap={2} alignItems="center">
          <Input
            placeholder="Enter Ticket ID"
            value={inputTicketID}
            onChange={(e) => setInputTicketID(e.target.value)}
            width="300px"
          />
          <Button colorScheme="teal" onClick={fetchTicketDetails}>Get Ticket Details</Button>
        </Box>
      </CardContainer>

      {loadingTD ? (
        <Box mt={4}>Loading ticket details...</Box>
      ) : ticketId && ticketDetails && Object.keys(ticketDetails).length > 0 ? (
        <>
          <CardContainer>
            <Text><b>Player:</b> {ticketDetails.player_id}</Text>
            <Text><b>Draw:</b> {ticketDetails.game_id}</Text>
            <Text><b>Draw Time:</b> {formatToIST(ticketDetails.draw_time)}</Text>
            <Text><b>Booking Time:</b> {formatToIST(ticketDetails.entry_time)}</Text>
            <Text><b>Status:</b> {ticketDetails.status}</Text>

            <Text fontWeight="bold" mt={3}>Bet Details:</Text>
            {(ticketDetails.bet_details || []).map((bet, i) => (
              <Text key={i}>
                <span className="label label-info">{bet.position}</span> → Qty: {bet.points}
              </Text>
            ))}
          </CardContainer>

          <CardContainer>
            <Text><b>Total Points:</b> {ticketDetails.total_points}</Text>
            {ticketDetails?.win_points > 0 ? (
              <Box bg="red.100" border="1px solid red" borderRadius="md" p={2} mt={3} display="inline-block">
                <Text color="red.800" fontWeight="bold">
                  Win Points: {ticketDetails.win_points}
                </Text>
              </Box>
            ) : (
              <Text><b>Win Points:</b> {ticketDetails?.win_points}</Text>
            )}
            <br />
            <Box bg="red.100" border="1px solid red" borderRadius="md" p={2} mt={3} display="inline-block">
              <Text color="red.800" fontWeight="bold">
                Win Position: {ticketDetails.win_position} ★ {ticketDetails.bonus}
              </Text>
            </Box>
          </CardContainer>
        </>
      ) : ticketId ? (
        <CardContainer>
          <Text color="red.500" fontWeight="bold">Ticket Details Not Available</Text>
        </CardContainer>
      ) : null}
    </Box>
  );
};

export default SearchBarcode;
